import { makeVar } from '@apollo/client';
import { getTimeByDate } from '@agentguru/helpers';
export var sortByAgencyOptions = [
    {
        id: 0,
        description: 'Creation Date',
        enabled: true,
        method: function (agency, nextAgency) {
            var aDate = getTimeByDate(String(agency.created_at));
            var bDate = getTimeByDate(String(nextAgency.created_at));
            if (aDate > bDate) {
                return -1;
            }
            if (aDate < bDate) {
                return 1;
            }
            return 0;
        },
    },
    {
        id: 1,
        description: 'Last Activity',
        enabled: true,
        method: function (agency, nextAgency) {
            var aDate = getTimeByDate(String(agency.created_at));
            var bDate = getTimeByDate(String(nextAgency.created_at));
            if (aDate > bDate) {
                return -1;
            }
            if (aDate < bDate) {
                return 1;
            }
            return 0;
        },
    },
    {
        id: 2,
        description: 'Alphabetical',
        enabled: true,
        method: function (agency, nextAgency) {
            var aName = String(agency.name);
            var bName = String(nextAgency.name);
            if (aName < bName) {
                return -1;
            }
            if (aName > bName) {
                return 1;
            }
            return 0;
        },
    },
];
export var AgencySort = makeVar(sortByAgencyOptions[0]);
